import firebaseApp from "../../firebase/credenciales";
import { getFirestore, deleteDoc, collection, doc } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function eliminarProveedor(proveedor) {  
  const coleccionRef = collection(db, "Proveedores");
  const docuRef = doc(coleccionRef, proveedor.trim());
  const eliminado = await deleteDoc(docuRef);
  return eliminado;
}
